import React from "react"
import HeaderComponent from "../Header/component"
import FooterComponent from "../Footer/component"

import "./styles.scss"
import { Link } from "react-router-dom"

export default function MainComponent() {
  return (
    <>
      <main id="main" class="site-main content-no-spacing home__wrapper">
        <HeaderComponent />
        <div class="content">
          <div class="clearfix">
            <section id="page-title" class="block with-img with-service-items">
              <div class="wrapper d-flex flex-column justify-content-center">
                <div class="page-title-body page-title-body-space-left">
                  <div class="title">
                    <h1 class="large">
                      Business <br />
                      Consulting Company
                    </h1>
                  </div>

                  <div class="description spacer p-top-lg">
                    <p>
                      We are digital business consulting company that helps
                      companies increase better incomes and help with branding
                      for faster business growing.
                    </p>
                  </div>

                  <div class="spacer p-top-lg">
                    <Link to="/about-us" class="btn btn-outline-tertiary">
                      Learn More
                    </Link>
                  </div>
                </div>

                <div class="page-title-footer full-width">
                  <div class="d-flex justify-content-between">
                    <a href="#services" class="scroll-to-id scroll-animation">
                      <i class="malex-icon-long-arrow-down i-large-2"></i>
                    </a>

                    {/* <div class="align-self-end">
                      <nav class="languages">
                        <ul class="nav">
                          <li class="lang-item current-lang">
                            <a title="En" href="index.html">
                              En
                            </a>
                          </li>

                          <li class="lang-item">
                            <a title="Ru" href="index.html">
                              Ru
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div> */}
                  </div>
                </div>
              </div>

              <div class="page-title-bg-color"></div>
            </section>

            <div id="services" class="block">
              <div class="wrapper">
                <div class="row gutter-width-md with-pb-md service-items">
                  <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="service">
                      <div class="service-icon">
                        <i class="fas fa-globe"></i>
                      </div>

                      <h4 class="service-t-head">Web Development</h4>

                      <p class="service-description">
                      Being a top-class web development company, we can create a web app that will resolve your industry-specific business challenges,
boost your efficiency, win new clients, and increase your user satisfaction rates.
                      </p>

                      <div class="service-btn">
                        <Link
                          title="Read more"
                          class="btn btn-sm btn-link btn-icon-hover p-0 border-0 min-w-auto link-no-space text-uppercase"
                          to="/web-development"
                        >
                          <i class="malex-icon-arrow-right i-large"></i>
                          <span class="btn-text">Read more</span>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="service">
                      <div class="service-icon">
                        <i class="fas fa-mobile-alt"></i>
                      </div>

                      <h4 class="service-t-head">App Development</h4>

                      <p class="service-description">
                      Mobile apps are the new frontier for business. Obtain a top-of-the-class custom mobile application of any complexity with
deep expertise and knowledge of the latest mobile development frameworks.
                      </p>

                      <div class="service-btn">
                        <Link
                          title="Read more"
                          class="btn btn-sm btn-link btn-icon-hover p-0 border-0 min-w-auto link-no-space text-uppercase"
                          to="/app-development"
                        >
                          <i class="malex-icon-arrow-right i-large"></i>
                          <span class="btn-text">Read more</span>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="service">
                      <div class="service-icon">
                        <i class="fab fa-mixcloud"></i>
                      </div>

                      <h4 class="service-t-head">DevOps Solution</h4>

                      <p class="service-description">
                      Our dedicated teams have the knowledge and expertise to help your company seamlessly migrate its digital assets,
resources, apps, services, and databases to the cloud — or create a new, robust cloud-based solutions.
                      </p>

                      <div class="service-btn">
                        <Link
                          title="Read more"
                          class="btn btn-sm btn-link btn-icon-hover p-0 border-0 min-w-auto link-no-space text-uppercase"
                          to="/dev-ops-solution"
                        >
                          <i class="malex-icon-arrow-right i-large"></i>
                          <span class="btn-text">Read more</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <section id="about-us" class="block spacer p-top-xl">
              <div class="wrapper">
                <div class="title">
                  <h6 class="text-primary text-uppercase">About Us</h6>
                </div>

                <div class="row gutter-width-md with-pb-md">
                  <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div class="description-2">
                      <h2>
                      Exclusive Company For Technology Provide solutions
                      </h2>
                    </div>

                    <div class="signature spacer m-top-lg">
                      {/* <div class="signature-img">
                        <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/23_img.png" alt="Signature" />
                      </div> */}

                      <div class="signature-content">
                        <h5 class="signature-name">Ankit Gupta</h5>
                        <p class="signature-position">CEO & CO FOUNDER</p>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div class="description-2">
                      <p>
                      Codebubble provides brands with a simpler means of building and growing their businesses.
They get to reach customers and clients faster, attend to their needs more efficiently, and improve their services daily.
Codebubble is a software development company focused on helping brands succeed in the digital space by building their online presence and connecting them with their target audience through professional and high effectively solutions.
The company is India based and has a local presence in MP, where they provide various high-end software services. These include web development, mobile app development, CMS Development, Angular, Vue.js development, digital marketing services, social media services, visual communication, content creation, and digital strategy.
                      </p>
                    </div>

                    <div class="description-2 spacer p-top-lg">
                      <p>
                        Marketing consultant is an advisor who works with
                        companies to create and implement marketing strategies.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="icon-list">
                  <div class="icon-list-items">
                    <div class="icon-list-item">
                      <p>
                        <span class="d-flex">
                          <i class="fas fa-check"></i>
                          <span>Constant Improvement</span>
                        </span>
                      </p>
                    </div>

                    <div class="icon-list-item">
                      <p>
                        <span class="d-flex">
                          <i class="fas fa-check"></i>
                          <span>Commitment to Customers</span>
                        </span>
                      </p>
                    </div>

                    <div class="icon-list-item">
                      <p>
                        <span class="d-flex">
                          <i class="fas fa-check"></i>
                          <span>Best Quality You Can Get</span>
                        </span>
                      </p>
                    </div>

                    <div class="icon-list-item">
                      <p>
                        <span class="d-flex">
                          <i class="fas fa-check"></i>
                          <span>30 Days Money Back Warranty</span>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div id="img" class="block spacer p-top-lg wrapper-normal">
              <div class="wrapper">
                <div class="img-size-1">
                  <div class="img object-fit">
                    <div class="object-fit-cover">
                      <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/02_img.jpg" alt="Team" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <section id="how-it-works" class="block bg-white before-block">
              <div class="wrapper">
                <div class="row no-gutters process-height">
                  <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                    <div class="process pl-0">
                      <div class="process-content">
                        <h6 class="process-small-t-head">How it Works?</h6>

                        <div class="process-description">
                          <h2>We Guarantee a Stable Work Process</h2>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                    <div class="process process-color-1">
                      <div class="process-content">
                        <h4 class="process-t-head">Business Analysis</h4>
                        <p class="process-description">
                          At vero eos et accusamus et iusto odio dignissimos
                          ducimus qui blanditiis praesentium.
                        </p>
                      </div>

                      <div class="process-number">01</div>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                    <div class="process process-color-2">
                      <div class="process-content">
                        <h4 class="process-t-head">Business Planning</h4>
                        <p class="process-description">
                          At vero eos et accusamus et iusto odio dignissimos
                          ducimus qui blanditiis praesentium.
                        </p>
                      </div>

                      <div class="process-number">02</div>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                    <div class="process process-color-3">
                      <div class="process-content">
                        <h4 class="process-t-head">Business Growth</h4>
                        <p class="process-description">
                          At vero eos et accusamus et iusto odio dignissimos
                          ducimus qui blanditiis praesentium.
                        </p>
                      </div>

                      <div class="process-number">03</div>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}

            <section
              id="team-members"
              class="block bg-white-before spacer p-top-xl p-bottom-xl"
            >
              <div class="wrapper">
                <div class="title">
                  <h6 class="text-primary text-uppercase">Meet our team</h6>
                </div>

                <div class="title-opacity">
                  <div class="title-opacity-text">Team</div>
                </div>

                <div class="description">
                  <h2>We are Business Consulting Professionals</h2>
                </div>

                <div class="row gutter-width-md with-pb-md spacer p-top-lg">
                  <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="team-member">
                      <div class="team-member-top">
                        <div class="img object-fit">
                          <div class="object-fit-cover">
                            <img
                              src="/img/033_img.jpg"
                              alt="Ankit Gupta"
                            />
                          </div>
                        </div>

                        <div class="team-member-position">
                          <p>CEO & CO FOUNDER</p>
                        </div>
                      </div>

                      <div class="team-member-content">
                        <h4 class="team-member-t-head">Ankit Gupta</h4>

                        {/* <div class="team-member-description">
                          <p>
                            At vero eos et accusamus et iusto odio dignissimos
                            ducimus qui blanditiis praesentium.
                          </p>
                        </div> */}
                      </div>

                      <nav class="team-member-nav-items">
                        <ul class="nav">
                          <li class="nav-item">
                            <a
                              title="Facebook"
                              href="https://www.facebook.com/ankit25/"
                            >
                              <i class="fab fa-facebook-f"></i>
                            </a>
                          </li>

                          <li class="nav-item">
                            <a
                              title="LinkedIn"
                              href="https://www.linkedin.com/in/happygupta25/"
                            >
                              <i class="fab fa-linkedin-in"></i>
                            </a>
                          </li>

                          <li class="nav-item">
                            <a
                              title="Instagram"
                              href="https://www.instagram.com/happygupta25/"
                            >
                              <i class="fab fa-instagram"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="team-member">
                      <div class="team-member-top">
                        <div class="img object-fit">
                          <div class="object-fit-cover">
                            <img
                              src="/img/044_img.jpg"
                              alt="Shuchi Gupta"
                            />
                          </div>
                        </div>

                        <div class="team-member-position">
                          <p>TEAM LEAD – ANDROID</p>
                        </div>
                      </div>

                      <div class="team-member-content">
                        <h4 class="team-member-t-head">Shuchi Gupta</h4>

                        {/* <div class="team-member-description">
                          <p>
                            At vero eos et accusamus et iusto odio dignissimos
                            ducimus qui blanditiis praesentium.
                          </p>
                        </div> */}
                      </div>

                      <nav class="team-member-nav-items">
                        <ul class="nav">
                          <li class="nav-item">
                            <a
                              title="Facebook"
                              href="https://www.facebook.com/shuchigupta4"
                            >
                              <i class="fab fa-facebook-f"></i>
                            </a>
                          </li>

                          <li class="nav-item">
                            <a
                              title="LinkedIn"
                              href="https://www.linkedin.com/in/shuchi-gupta-4067865a/"
                            >
                              <i class="fab fa-linkedin-in"></i>
                            </a>
                          </li>

                          <li class="nav-item">
                            <a
                              title="Instagram"
                              href="https://www.instagram.com/shuchigupta4/"
                            >
                              <i class="fab fa-instagram"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="team-member">
                      <div class="team-member-top">
                        <div class="img object-fit">
                          <div class="object-fit-cover">
                            <img
                              src="/img/055_img.jpg"
                              alt="Priyank Bahre"
                            />
                          </div>
                        </div>

                        <div class="team-member-position">
                          <p>BUSINESS MANAGEMENT</p>
                        </div>
                      </div>

                      <div class="team-member-content">
                        <h4 class="team-member-t-head">Priyank Bahre</h4>

                        {/* <div class="team-member-description">
                          <p>
                            At vero eos et accusamus et iusto odio dignissimos
                            ducimus qui blanditiis praesentium.
                          </p>
                        </div> */}
                      </div>

                      <nav class="team-member-nav-items">
                        <ul class="nav">
                          <li class="nav-item">
                            <a
                              title="Facebook"
                              href="https://www.facebook.com/priyank.bahre"
                            >
                              <i class="fab fa-facebook-f"></i>
                            </a>
                          </li>

                          <li class="nav-item">
                            <a
                              title="LinkedIn"
                              href="https://www.linkedin.com/in/priyank-bahre-0a245b34/"
                            >
                              <i class="fab fa-linkedin-in"></i>
                            </a>
                          </li>

                          <li class="nav-item">
                            <a
                              title="Instagram"
                              href="https://www.instagram.com/priyankbah/"
                            >
                              <i class="fab fa-instagram"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* <section id="price-plans" class="block spacer p-top-xl">
              <div class="wrapper">
                <div class="title">
                  <h6 class="text-primary text-uppercase">Price Plans</h6>
                </div>

                <div class="title-opacity">
                  <div class="title-opacity-text">Plans</div>
                </div>

                <div class="description">
                  <h2>Choose the Best Plan for You</h2>
                </div>

                <div class="row gutter-width-md with-pb-md spacer p-top-lg">
                  <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="price-table">
                      <div class="price-table-header">
                        <h4 class="price-table-t-head">Basic Plan</h4>
                        <p class="price-table-description">
                          This is Basic Plan
                        </p>
                      </div>

                      <div class="price-table-price">
                        <p>
                          <span class="currency">$</span>
                          <span class="price">79</span>
                          <span class="period">/ Monthly</span>
                        </p>
                      </div>

                      <ul class="price-table-list-group list-group">
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          Branding
                          <i class="text-primary fas fa-check i-small"></i>
                        </li>

                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          20 hours of consultation
                          <i class="text-primary fas fa-check i-small"></i>
                        </li>

                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          15 hours if theory
                          <i class="text-primary fas fa-check i-small"></i>
                        </li>

                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          Skype video call
                          <i class="text-primary fas fa-check i-small"></i>
                        </li>

                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          Support 24/7
                          <i class="text-primary fas fa-check i-small"></i>
                        </li>
                      </ul>

                      <div class="price-table-footer">
                        <a
                          href="#"
                          class="btn btn-outline-secondary"
                          data-toggle="modal"
                          data-target="#plans-modal"
                          data-whatever="Basic Plan"
                        >
                          Choose Plan
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="price-table">
                      <div class="price-table-header">
                        <h4 class="price-table-t-head">Standart Plan</h4>
                        <p class="price-table-description">
                          This is Standart Plan
                        </p>
                      </div>

                      <div class="price-table-price">
                        <p>
                          <span class="currency">$</span>
                          <span class="price">129</span>
                          <span class="period">/ Monthly</span>
                        </p>
                      </div>

                      <ul class="price-table-list-group list-group">
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          Branding
                          <i class="text-primary fas fa-check i-small"></i>
                        </li>

                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          20 hours of consultation
                          <i class="text-primary fas fa-check i-small"></i>
                        </li>

                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          15 hours if theory
                          <i class="text-primary fas fa-check i-small"></i>
                        </li>

                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          Skype video call
                          <i class="text-primary fas fa-check i-small"></i>
                        </li>

                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          Support 24/7
                          <i class="text-primary fas fa-check i-small"></i>
                        </li>
                      </ul>

                      <div class="price-table-footer">
                        <a
                          href="#"
                          class="btn btn-outline-secondary"
                          data-toggle="modal"
                          data-target="#plans-modal"
                          data-whatever="Standart Plan"
                        >
                          Choose Plan
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div class="price-table">
                      <div class="price-table-badge">
                        <p>Popular</p>
                      </div>

                      <div class="price-table-header">
                        <h4 class="price-table-t-head">Premium Plan</h4>
                        <p class="price-table-description">
                          This is Premium Plan
                        </p>
                      </div>

                      <div class="price-table-price">
                        <p>
                          <span class="currency">$</span>
                          <span class="price">259</span>
                          <span class="period">/ Monthly</span>
                        </p>
                      </div>

                      <ul class="price-table-list-group list-group">
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          Branding
                          <i class="text-primary fas fa-check i-small"></i>
                        </li>

                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          20 hours of consultation
                          <i class="text-primary fas fa-check i-small"></i>
                        </li>

                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          15 hours if theory
                          <i class="text-primary fas fa-check i-small"></i>
                        </li>

                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          Skype video call
                          <i class="text-primary fas fa-check i-small"></i>
                        </li>

                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          Support 24/7
                          <i class="text-primary fas fa-check i-small"></i>
                        </li>
                      </ul>

                      <div class="price-table-footer">
                        <a
                          href="#"
                          class="btn btn-outline-secondary"
                          data-toggle="modal"
                          data-target="#plans-modal"
                          data-whatever="Premium Plan"
                        >
                          Choose Plan
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}

            {/* <div id="clients" class="block bg-white spacer m-top-xl">
              <div class="wrapper">
                <div class="clients">
                  <div class="clients-items">
                    <div class="clients-item">
                      <div class="clients-item-content">
                        <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/06_img.png" alt="Balkan" />
                      </div>
                    </div>

                    <div class="clients-item">
                      <div class="clients-item-content">
                        <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/07_img.png" alt="Adveits" />
                      </div>
                    </div>

                    <div class="clients-item">
                      <div class="clients-item-content">
                        <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/08_img.png" alt="Swiger" />
                      </div>
                    </div>

                    <div class="clients-item">
                      <div class="clients-item-content">
                        <img
                          src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/09_img.png"
                          alt="The mandala community"
                        />
                      </div>
                    </div>

                    <div class="clients-item">
                      <div class="clients-item-content">
                        <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/06_img.png" alt="Balkan" />
                      </div>
                    </div>

                    <div class="clients-item">
                      <div class="clients-item-content">
                        <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/07_img.png" alt="Adveits" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <div id="video" class="block">
              <div class="embed">
                <div class="embed-image-overlay">
                  <a
                    class="embed-click swipebox"
                    href="https://www.youtube.com/watch?v=lSNmfy_KOJg"
                  >
                    <div class="embed-center">
                      <div class="embed-play">
                        <i class="fas fa-play"></i>
                      </div>
                    </div>
                  </a>

                  <div class="embed-image">
                    <div class="img object-fit">
                      <div class="object-fit-cover">
                        <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/10_img.jpg" alt="Video" />
                      </div>
                    </div>
                  </div>

                  <div class="embed-bg"></div>
                </div>
              </div>
            </div>

            {/* <section
              id="testimonials"
              class="block bg-dark spacer p-top-xl p-bottom-xl"
            >
              <div class="wrapper">
                <div class="title">
                  <h6 class="text-primary text-uppercase">Testimonials</h6>
                </div>

                <div class="description text-tertiary">
                  <h2>Our Happy Customers Reviews</h2>
                </div>

                <div class="adv-slider-reviews text-tertiary">
                  <div class="adv-slider-reviews-img">
                    <img src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/11_img.png" alt="Icon" />
                  </div>

                  <div class="adv-swiper-container reviews-text">
                    <div class="adv-swiper-wrapper reviews-text-items">
                      <div class="adv-swiper-slide reviews-text-item">
                        <div class="reviews-text-item-content">
                          <h3>
                            But I must explain to you how all this mistaken idea
                            of denouncing pleasure and praising pain was born
                            and I will give you a complete account.
                          </h3>
                        </div>
                      </div>

                      <div class="adv-swiper-slide reviews-text-item">
                        <div class="reviews-text-item-content">
                          <h3>
                            But I must explain to you how all this mistaken idea
                            of denouncing pleasure and praising pain was born
                            and I will give you a complete account.
                          </h3>
                        </div>
                      </div>

                      <div class="adv-swiper-slide reviews-text-item">
                        <div class="reviews-text-item-content">
                          <h3>
                            But I must explain to you how all this mistaken idea
                            of denouncing pleasure and praising pain was born
                            and I will give you a complete account.
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-items-center thumbs">
                    <div class="adv-swiper-container reviews-thumbs">
                      <div class="adv-swiper-wrapper reviews-thumbs-items">
                        <div
                          class="adv-swiper-slide reviews-thumbs-item"
                          data-reviews-name="Tommy Andersen"
                          data-reviews-position="CEO at Company"
                        >
                          <img
                            src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/12_img.png"
                            alt="Tommy Andersen"
                          />
                        </div>

                        <div
                          class="adv-swiper-slide reviews-thumbs-item"
                          data-reviews-name="Arthur Hopin"
                          data-reviews-position="CEO at Company"
                        >
                          <img
                            src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/13_img.png"
                            alt="Arthur Hopin"
                          />
                        </div>

                        <div
                          class="adv-swiper-slide reviews-thumbs-item"
                          data-reviews-name="Rosie Ford"
                          data-reviews-position="CEO at Company"
                        >
                          <img
                            src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/14_img.png"
                            alt="Rosie Ford"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="reviews-results">
                      <h6 class="reviews-name" id="reviews-name">
                        Tommy Andersen
                      </h6>
                      <p class="reviews-positions" id="reviews-positions">
                        CEO at Company
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}

            {/* <section id="news" class="block spacer p-top-xl p-bottom-xl">
              <div class="wrapper">
                <div class="title">
                  <h6 class="text-primary text-uppercase">New Articles</h6>
                </div>

                <div class="title-opacity">
                  <div class="title-opacity-text">News</div>
                </div>

                <div class="description">
                  <h2>Check Our Latest Blog Posts</h2>
                </div>

                <div class="blog-shortcode">
                  <div class="row gutter-width-md with-pb-md spacer p-top-lg">
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                      <div class="card card-post">
                        <div class="card-top position-relative">
                          <a
                            title="5 Tips for Sustainable Business Success"
                            href="/news-single-post"
                          >
                            <div class="img object-fit overflow-hidden">
                              <div class="object-fit-cover transform-scale-h">
                                <img
                                  class="card-top-img"
                                  src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/20_img.jpg"
                                  alt="5 Tips for Sustainable Business Success"
                                />
                              </div>
                            </div>
                          </a>
                        </div>

                        <div class="card-body">
                          <h5 class="card-title">
                            <a
                              title="5 Tips for Sustainable Business Success"
                              href="/news-single-post"
                            >
                              5 Tips for Sustainable Business Success
                            </a>
                          </h5>

                          <p class="card-text">
                            At vero eos et accusamus et iusto odio dignissimos
                            ducims…
                          </p>

                          <div class="card-btn">
                            <a
                              title="Read more"
                              class="btn btn-sm btn-link btn-icon-hover p-0 border-0 min-w-auto link-no-space text-uppercase"
                              href="/news-single-post"
                            >
                              <i class="malex-icon-arrow-right i-large"></i>
                              <span class="btn-text">Read more</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                      <div class="card card-post">
                        <div class="card-top position-relative">
                          <a
                            title="Assessing the Maturity of Your Data Management in Industry"
                            href="/news-single-post"
                          >
                            <div class="img object-fit overflow-hidden">
                              <div class="object-fit-cover transform-scale-h">
                                <img
                                  class="card-top-img"
                                  src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/21_img.jpg"
                                  alt="Assessing the Maturity of Your Data Management in Industry"
                                />
                              </div>
                            </div>
                          </a>
                        </div>

                        <div class="card-body">
                          <h5 class="card-title">
                            <a
                              title="Assessing the Maturity of Your Data Management in Industry"
                              href="/news-single-post"
                            >
                              Assessing the Maturity of Your Data Management in
                              Industry
                            </a>
                          </h5>

                          <p class="card-text">
                            At vero eos et accusamus et iusto odio dignissimos
                            ducims…
                          </p>

                          <div class="card-btn">
                            <a
                              title="Read more"
                              class="btn btn-sm btn-link btn-icon-hover p-0 border-0 min-w-auto link-no-space text-uppercase"
                              href="/news-single-post"
                            >
                              <i class="malex-icon-arrow-right i-large"></i>
                              <span class="btn-text">Read more</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                      <div class="card card-post">
                        <div class="card-top position-relative">
                          <Link
                            title="How to Build Your Sustainable Susiness Strategy"
                            to="/news-single-post"
                          >
                            <div class="img object-fit overflow-hidden">
                              <div class="object-fit-cover transform-scale-h">
                                <img
                                  class="card-top-img"
                                  src="https://store.adveits.com/project/malex/html/demo/assets/img/demo/22_img.jpg"
                                  alt="How to Build Your Sustainable Susiness Strategy"
                                />
                              </div>
                            </div>
                          </Link>
                        </div>

                        <div class="card-body">
                          <h5 class="card-title">
                            <Link
                              title="How to Build Your Sustainable Susiness Strategy"
                              to="/news-single-post"
                            >
                              How to Build Your Sustainable Susiness Strategy
                            </Link>
                          </h5>

                          <p class="card-text">
                            At vero eos et accusamus et iusto odio dignissimos
                            ducims…
                          </p>

                          <div class="card-btn">
                            <Link
                              title="Read more"
                              class="btn btn-sm btn-link btn-icon-hover p-0 border-0 min-w-auto link-no-space text-uppercase"
                              to="/news-single-post"
                            >
                              <i class="malex-icon-arrow-right i-large"></i>
                              <span class="btn-text">Read more</span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="spacer m-top-lg text-right">
                  <a
                    title="View all news"
                    class="btn btn-outline-secondary"
                    href="news.html"
                  >
                    View All Posts
                  </a>
                </div>
              </div>
            </section> */}

            <section
              id="contacts"
              class="block bg-white-before spacer p-top-xl"
            >
              <div class="wrapper">
                <div class="title">
                  <h6 class="text-primary text-uppercase">Contacts</h6>
                </div>

                <div class="title-opacity">
                  <div class="title-opacity-text">Contacts</div>
                </div>

                <div class="description-lg">
                  <h2>
                    Any Questions? Contact us Freely and We'll Get Back to You
                    Shortly
                  </h2>
                </div>

                <div class="spacer p-top-lg">
                  <div class="row gutter-width-md with-pb-md">
                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                      <div class="contacts-item">
                        <div class="contacts-item-icon">
                          <i class="malex-icon-location"></i>
                        </div>

                        <h5 class="contacts-item-t-head">Location</h5>

                        <p class="contacts-item-description">
                          Location: Eldora 2/207 Apollo DB City
                          <br />
                          Indore M.P
                        </p>
                      </div>
                    </div>

                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                      <div class="contacts-item">
                        <div class="contacts-item-icon">
                          <i class="malex-icon-phone"></i>
                        </div>

                        <h5 class="contacts-item-t-head">Phone no.</h5>

                        <p class="contacts-item-description">
                          Mobile: <a href="tel:+43253312523">+919479900088</a>
                          {/* <br />
                          Fax: <a href="tel:+53222212523">+532 222 12 523</a> */}
                        </p>
                      </div>
                    </div>

                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                      <div class="contacts-item">
                        <div class="contacts-item-icon">
                          <i class="malex-icon-email"></i>
                        </div>

                        <h5 class="contacts-item-t-head">E-mail</h5>

                        <p class="contacts-item-description">
                          Info:{" "}
                          <a href="mailto:sales@codebubbletech.com">sales@codebubbletech.com</a>
                          {/* <br />
                          CEO:{" "}
                          <a href="mailto:ceo@domain.com">ceo@domain.com</a> */}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="width-img spacer p-top-xl p-bottom-xl">
                <div class="wrapper">
                  <div id="contact-form">
                    <div class="title">
                      <h3 class="pb-0">How May We Help You!</h3>
                    </div>

                    {/* <div class="description-lg spacer p-top-lg">
                      <p>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. When an unknown printer took a
                        galley.
                      </p>
                    </div> */}

                    <div class="spacer p-top-lg">
                      <form
                        method="post"
                         
                        id="cf-1"
                        class="contact-form"
                      >
                        <div class="form-group form-group-xs">
                          <input
                            name="cf-1-name"
                            type="text"
                            class="form-control form-control-lg bg-gray-light"
                            id="cf-1-name"
                            placeholder="Name"
                            required="required"
                          />
                        </div>

                        <div class="form-group form-group-xs">
                          <input
                            name="cf-1-email"
                            type="email"
                            class="form-control form-control-lg bg-gray-light"
                            id="cf-1-email"
                            placeholder="Email"
                            required="required"
                          />
                        </div>

                        <div class="form-group form-group-xs">
                          <textarea
                            name="cf-1-message"
                            class="form-control form-control-lg bg-gray-light"
                            id="cf-1-message"
                            placeholder="Message"
                            required="required"
                          ></textarea>
                        </div>

                        <div class="form-group form-group-xs mb-0">
                          <button
                            type="submit"
                            class="btn btn-outline-secondary"
                          >
                            Send Message
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>

      <FooterComponent />
    </>
  )
}
